import React, { useEffect, useState, useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import toastStore from '../../store/toast-store';
import { useTranslation } from 'react-i18next';

interface MobileRouteGuardProps {
  children: React.ReactNode;
}

/**
 * Composant qui protège les routes contre l'accès mobile
 * Redirige vers la page d'accueil si l'utilisateur est sur mobile
 */
const MobileRouteGuard: React.FC<MobileRouteGuardProps> = ({ children }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const toastShownRef = useRef(false); // Référence pour suivre si le toast a déjà été affiché

  useEffect(() => {
    // Vérifier si l'utilisateur est sur mobile (largeur d'écran < 768px)
    const checkMobile = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      setIsChecked(true);
      
      // Afficher le toast uniquement si on est sur mobile et qu'il n'a pas déjà été affiché
      if (mobile && !toastShownRef.current) {
        toastStore.addToast('info', t('common.mobileNotAvailable'));
        toastShownRef.current = true; // Marquer le toast comme affiché
      }
    };

    // Vérifier immédiatement
    checkMobile();

    // Ajouter un écouteur pour les changements de taille d'écran
    window.addEventListener('resize', checkMobile);

    // Nettoyer l'écouteur
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, [t]);

  // Attendre que la vérification soit terminée
  if (!isChecked) {
    return null; // ou un loader si nécessaire
  }

  // Si c'est un mobile, rediriger vers la page d'accueil
  if (isMobile) {
    window.location.href = process.env.REACT_APP_HOME_URL || 'https://prestaslot.com';
    return null;
  }

  // Sinon, afficher le contenu normalement
  return <>{children}</>;
};

export default MobileRouteGuard;
